import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import moment from 'moment'

import latoBold from '../../../fonts/Lato-Bold.ttf'
import ladoRegular from '../../../fonts/Lato-Regular.ttf'

Font.register({
    family: 'Lato',
    fonts: [
        {
            src: ladoRegular
        },
        {
            src: latoBold,
            fontWeight: 'bold'
        }
    ]
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Lato',
        backgroundColor: 'white',
        fontSize: 10,
        padding: 30,
        marginTop: 20
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
    },
    header2: {
        marginTop: -5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'start',
        alignContent: 'center',
    },
    infoCliente: {
        marginTop: 10
    },
    dato: {
        marginTop: 5,
        display: 'flex',
        flexDirection: 'row'
    },
    dato2: {
        marginTop: 8,
        display: 'flex',
        flexDirection: 'row'
    },
    referencia: {
        marginTop: 15,
        color: '#483B4C',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 9
    },
    table: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: 2,
        paddingTop: 2,
        paddingBottom: 2,
        borderBottomColor: '#8E24AA',
        fontWeight: '400',
        color: '#483B4C'
    },
    table2: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: 1,
        paddingTop: 2,
        paddingBottom: 2,
        borderBottomColor: 'lightgray',
        fontWeight: '400',
        color: '#483B4C'
    },
    title: {
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#FAF9FA',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 10,
        fontWeight: '600',
        textTransform: 'uppercase'
    },
    item: {
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 10,
        fontWeight: '400',
        textTransform: 'capitalize'
    },
    pptoTitle: {
        color: '#8E24AA',
        fontFamily: 'Lato',
        fontWeight: 'bold',
    },
    labelNameFecha: {
        color: '#483B4C',
        marginTop: 5
    },
    labelNameNro: {
        color: '#483B4C',
        fontSize: 11,
        fontWeight: '600'
    },
    labelName: {
        color: '#483B4C',
        width: 80,
    },
    labelName2: {
        color: '#483B4C',
        width: 100,
    },
    labelValue: {
        color: '#78667E',
        fontSize: 9,
        textTransform: 'uppercase'
    },
    wrapTotales: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    totales: {
        marginTop: 10,
        padding: 5,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        backgroundColor: '#FAF9FA',
        fontStyle: 'normal',
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    labelNameTotal: {
        color: '#483B4C',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9
    },
    labelValueTotal: {
        color: '#483B4C',
        fontWeight: 400,
        width: 110,
        fontSize: 10,
        textAlign: 'right'
    },
    labelNameIGV: {
        color: '#78667E',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9,
        textTransform: 'none'
    },
})

const formatNumber = (value = 0, currency = null) => {

    let country = {
        iso: 'en-US',
        currency: 'USD',
        decimales: 0
    }

    if (currency === 'S/') {
        country.iso = 'es-PE'
        country.currency = 'PEN'
        country.decimales = 2
    }

    const formatter = new Intl.NumberFormat(country.iso, {
        style: 'currency',
        currency: country.currency,
        maximumFractionDigits: country.decimales,
        minimumFractionDigits: country.decimales
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    })

    return formatter.format(value)

}

export const PdfFile = ({ auth, infoEmp, dataPreview, viewOptions, urlLogo, paymentStatus }) => {

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                <View style={styles.header}>
                    <View>
                        <Text style={[styles.pptoTitle, { textTransform: 'uppercase' }]}>{dataPreview.docName || 'comprobante'}</Text>
                    </View>
                    <View>
                        <Image
                            style={{
                                width: 90,
                                height: 'auto',
                                maxHeight: 50,
                                marginTop: 20,
                                marginRight: 15,
                            }}
                            src={urlLogo}
                            alt="logo"
                        />
                    </View>
                </View>

                <View style={styles.header2}>
                    <Text style={styles.labelNameNro}>{`#0000${dataPreview.numero}`}</Text>
                    <Text style={styles.labelNameFecha}>{moment(dataPreview.fecha_emision).format('DD MMMM YYYY')}</Text>
                </View>

                <InfoCliente
                    auth={auth}
                    info={dataPreview}
                />

                <View style={styles.referencia}>
                    <Text style={{ textTransform: 'uppercase' }}>{dataPreview.referencia}</Text>
                </View>

                <Items
                    info={dataPreview}
                    viewOptions={viewOptions}
                />

                <Totales
                    info={dataPreview}
                    viewOptions={viewOptions}
                />

                <Condiciones
                    info={dataPreview}
                />

                <StatusCobrosRecibo
                    info={dataPreview}
                />

                <StatusCobros
                    info={dataPreview}
                    paymentStatus={paymentStatus}
                />

            </Page>
        </Document >
    )
}

const Items = ({ info, viewOptions }) => {

    return (
        <>

            <View style={styles.table}>
                <Text style={{ width: 200, textAlign: 'left' }}>Ítems</Text>
                <Text style={{ width: 100, textAlign: 'center' }}>Cant.</Text>
                <Text style={{ width: 100, textAlign: 'right' }}>P. Unitario</Text>
                <Text style={{ width: 100, textAlign: 'right' }}>Subtotal</Text>
            </View>

            {info?.items?.map((item, index) => {
                return (
                    <View style={styles.item} key={index}>
                        <Text style={{ width: 200, textAlign: 'left' }}>
                            <Text>{item.nombre}</Text>
                        </Text>
                        <Text style={{ width: 100, textAlign: 'center' }}>{item.cantidad}</Text>
                        <Text style={{ width: 100, textAlign: 'right' }}>
                            {formatNumber(item.precio_unitario, info.simbolo)}
                        </Text>
                        <Text style={{ width: 100, textAlign: 'right' }}>
                            {formatNumber(item.subtotal, info.simbolo)}
                        </Text>
                    </View>
                )
            })}

        </>
    )
}

const InfoCliente = ({ auth, info }) => {
    return (
        <>
            <View style={styles.infoCliente}>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Cliente:</Text>
                    <Text style={styles.labelValue}>{info?.cliente || 'N/A'}</Text>
                </View>

                {info?.ruc &&
                    <View style={styles.dato}>
                        <Text style={styles.labelName}>RUC:</Text>
                        <Text style={styles.labelValue}>{info?.ruc || 'N/A'}</Text>
                    </View>
                }

                <View style={{
                    backgroundColor: info.estado === 'pagada' ? '#86efac' : '#bfdbfe',
                    color: info.estado === 'pagada' ? '#166534' : '#5b7df8',
                    borderRadius: '4px',
                    padding: '3px',
                    width: '55px',
                    textTransform: 'uppercase',
                    fontSize: '8px',
                    marginTop: '4px',
                    fontWeight: 'bold',
                    textAlign: 'center'

                }}>
                    <Text>{info.estado !== 'pagada' ? 'Pendiente' : info.estado}</Text>
                </View>

            </View>
        </>
    )
}

const Totales = ({ info }) => {
    return (
        <View style={styles.wrapTotales}>
            <View style={{ width: '58%' }}></View>
            <View style={[styles.totales, { width: '42%' }]}>

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>SUBTOTAL</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.subtotal}
                        </Text>
                    </View>
                }

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>( {info.descuento_porcentaje}% )  DESC</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.descuento}
                        </Text>
                    </View>
                }

                {parseFloat(info.impuesto_porcentaje) > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>TOTAL BASE</Text>
                        <Text style={styles.labelValueTotal}>
                            {formatNumber(info.monto_base, info.simbolo)}
                        </Text>
                    </View>
                }

                {parseFloat(info.impuesto_porcentaje) > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>( {parseFloat(info.impuesto_porcentaje).toFixed(0)}% )  IGV</Text>
                        <Text style={styles.labelValueTotal}>
                            {formatNumber(info.total_impuesto, info.simbolo)}
                        </Text>
                    </View>
                }

                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>TOTAL</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.total_factura, info.simbolo)}
                    </Text>
                </View>

            </View>
        </View>
    )
}

const Condiciones = ({ info }) => {

    return (
        <>
            <View style={[styles.table, { marginBottom: 10 }]}>
                <Text>Condiciones</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Forma de pago:</Text>
                <Text style={styles.labelValue}>{info.payFormsName || ''}</Text>
            </View>
            {info.observaciones &&
                <View style={styles.dato}>
                    <Text style={styles.labelName2}>Observaciones:</Text>
                    <Text style={styles.labelValue}>{info.observaciones || 'N/A'}</Text>
                </View>
            }

            {/* <View style={styles.dato}>
                <Text style={{
                    marginTop: '20px',
                }}>** Copia no válida para efectos tributarios.</Text>
            </View> */}

        </>
    )
}

const StatusCobrosRecibo = ({ info }) => {

    const { total_factura, total_cobrado, total_por_cobrar } = info

    return (
        <>
            <View style={[styles.table, { marginBottom: 10 }]}>
                <Text>Estado de Cobros del Recibo</Text>
            </View>

            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <View>
                    <Text style={{ color: '#483B4C' }}>Total Facturado</Text>
                    <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_factura, info.simbolo)}</Text>
                </View>
                <View>
                    <Text style={{ color: '#483B4C' }}>Total Abonado</Text>
                    <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_cobrado, info.simbolo)}</Text>
                </View>
                <View>
                    <Text style={{ color: '#483B4C' }}>Saldo</Text>
                    <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_por_cobrar, info.simbolo)}</Text>
                </View>
            </View>

        </>
    )
}

const StatusCobros = ({ info, paymentStatus }) => {

    const { total_budget, total_payments, total_balance, payments } = paymentStatus

    return (
        <>
            <View style={[styles.table, { marginBottom: 10 }]}>
                <Text>Estado de Cobros del Proyecto</Text>
            </View>

            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                {(paymentStatus?.payments?.length > 0) ?
                    <>
                        <View>
                            <Text style={{ color: '#483B4C' }}>Presupuesto Aprobado</Text>
                            <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_budget, info.simbolo)}</Text>
                        </View>
                        <View>
                            <Text style={{ color: '#483B4C' }}>Total Abonado</Text>
                            <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_payments, info.simbolo)}</Text>
                        </View>
                        <View>
                            <Text style={{ color: '#483B4C' }}>Saldo</Text>
                            <Text style={{ color: '#78667E', textAlign: 'right' }}>{formatNumber(total_balance, info.simbolo)}</Text>
                        </View>
                    </> :
                    <View>
                        <Text style={{ color: '#483B4C' }}>No hay cobros registrados.</Text>
                    </View>
                }
            </View>

            {(paymentStatus?.payments?.length > 0) ?
                <ItemsStatusCobros
                    info={info}
                    payments={payments}
                /> : ''
            }

            <View style={styles.dato}>
                <Text style={{
                    marginTop: '20px',
                }}>** Copia no válida para efectos tributarios.</Text>
            </View >

        </>
    )
}

const ItemsStatusCobros = ({ info, payments }) => {

    return (
        <>

            <View style={[styles.table2, { paddingLeft: 2, paddingRight: 2, fontSize: 9, borderBottom: 1.5, borderBottomColor: 'lightgray' }]}>
                <Text style={{ width: 200, textAlign: 'left' }}>Fecha Cobro</Text>
                <Text style={{ width: 200, textAlign: 'center' }}>Documento</Text>
                <Text style={{ width: 150, textAlign: 'center' }}>Ítem / Concepto</Text>
                <Text style={{ width: 150, textAlign: 'right' }}>Monto</Text>
                <Text style={{ width: 150, textAlign: 'center' }}>Estado</Text>
            </View >

            {
                payments.map((item, index) => {
                    return (
                        <View style={[styles.item, { fontSize: 9, borderBottom: 1, borderBottomColor: 'lightgray' }]} key={index}>
                            <Text style={{ width: 200, textAlign: 'left' }}>{moment(item.date).format('DD-MM-YYYY')}</Text>
                            <Text style={{ width: 200, textAlign: 'center' }}>{`${item.invoice_ref} / ${item.invoice_nro}` || '---'}</Text>
                            <Text style={{ width: 150, textAlign: 'center' }}>{item?.concept || '---'}</Text>
                            <Text style={{ width: 150, textAlign: 'right' }}>{formatNumber(item.amount, info.simbolo)}</Text>
                            <Text style={{ width: 150, textAlign: 'center', color: 'green', textTransform: 'capitalize' }}>{item.state}</Text>
                        </View>
                    )
                })
            }

        </>
    )
}